import { i as isObj } from './isObj-665859c3.js';
import { i as isFunction, a as isUndefined } from './typeof-eb42a279.js';

/**
 * @file: 复杂数据类型校验
 * @author: sunziwen(sunziwen@baidu.com)
 */
var kindOf = (function (cache) {
    return function (thing) {
        var str = Object.prototype.toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    };
})(Object.create(null));
function kindOfTest(type) {
    type = type.toLowerCase();
    return function isKindOf(thing) {
        return kindOf(thing) === type;
    };
}
/**
 * 是否 isStream
 * @param {any} val 输入
 * @return {boolean} 结果
 */
function isStream(val) {
    return isObj(val) && isFunction(val.pipe);
}
/**
 * 是否 isBuffer
 * @param {any} val 输入
 * @return {boolean} 结果
 */
function isBuffer(val) {
    return (val !== null
        && !isUndefined(val)
        && val.constructor !== null
        && !isUndefined(val.constructor)
        && typeof val.constructor.isBuffer === 'function'
        && val.constructor.isBuffer(val));
}
/**
 * 是否 ArrayBuffer
 * @param {any} val 输入
 * @return {boolean} 结果
 */
var isArrayBuffer = kindOfTest('ArrayBuffer');
/**
 * 是否 ArrayBuffer
 * @param {any} val 输入
 * @return {boolean} 结果
 */
var isDate = kindOfTest('Date');
/**
 * 是否 ArrayBuffer
 * @param {any} val 输入
 * @return {boolean} 结果
 */
var isFormData = kindOfTest('FormData');
/**
 * 是否 File
 * @param {any} val 输入
 * @return {boolean} 结果
 */
var isFile = kindOfTest('File');
/**
 * 是否 Blob
 * @param {any} val 输入
 * @return {boolean} 结果
 */
var isBlob = kindOfTest('Blob');
/**
 * 是否 URLSearchParams
 * @param {any} val 输入
 * @return {boolean} 结果
 */
var isURLSearchParams = kindOfTest('URLSearchParams');
/**
 * 是否 Array
 * @param {any} val 输入
 * @return {boolean} 结果
 */
var isArray = kindOfTest('Array');
/**
 * 是否 Set
 * @param {any} val 输入
 * @return {boolean} 结果
 */
var isSet = kindOfTest('Set');
/**
 * 是否 Map
 * @param {any} val 输入
 * @return {boolean} 结果
 */
var isMap = kindOfTest('Map');

export { isArrayBuffer as a, isBlob as b, isBuffer as c, isDate as d, isFile as e, isFormData as f, isMap as g, isSet as h, isArray as i, isStream as j, isURLSearchParams as k };
//# sourceMappingURL=instanceof-467ce6ea.js.map
